var _dec, _dec2, _dec3, _class, _class2, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import { traitClass } from "../Trait";
import mixTraits from "../mixTraits";
import GltfCatalogItemTraits from "./GltfCatalogItemTraits";
let AssImpCatalogItemTraits = (_dec = traitClass({
  description: "Creates one catalog item from url that points to a 3d model.",
  example: {
    type: "assimp",
    name: "assimp example",
    urls: ["https://raw.githubusercontent.com/kovacsv/assimpjs/main/examples/testfiles/cube_with_materials.obj", "https://raw.githubusercontent.com/kovacsv/assimpjs/main/examples/testfiles/cube_with_materials.mtl"],
    baseUrl: "https://github.com/kovacsv/assimpjs/raw/main/examples/testfiles/",
    scale: 100,
    origin: {
      latitude: -42.8826,
      longitude: 147.3257,
      height: 100
    },
    rectangle: {
      west: 147.33,
      south: -42.9,
      east: 147.33,
      north: -42.87
    },
    id: "some unique id"
  }
}), _dec2 = primitiveArrayTrait({
  type: "string",
  name: "URLs",
  description: "An array of URLs"
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Base URL",
  description: "The base URL that paths in the 3D model (eg textures) are relative to"
}), _dec(_class = (_class2 = class AssImpCatalogItemTraits extends mixTraits(GltfCatalogItemTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "urls", _descriptor, this);
    _initializerDefineProperty(this, "baseUrl", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "urls", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "baseUrl", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { AssImpCatalogItemTraits as default };